/* eslint-disable no-console */
import {formatIndian} from '../../../utils/formatIndian';

export const returnMaxAndMin: (
  data: any[],
  keyFilter?: string
) => {
  max: any;
  min: any;
} = (data, keyFilter = 'value') => {
  return {
    max: data?.reduce((prev, current) => {
      return prev?.[keyFilter] > current?.[keyFilter] ? prev : current;
    }, null),
    min: data?.reduce((prev, current) => {
      return prev?.[keyFilter] < current?.[keyFilter] ? prev : current;
    }, null)
  };
};

export const formatNumber: (
  value: number,
  type?: 'lakhCrores' | 'millionBillion'
) => string = (value, type = 'lakhCrores') => {
  const num = value;
  const formatWithDecimals = (number: number) => {
    return formatIndian(
      Number(number % 1 === 0 ? number.toString() : number.toFixed(3))
    );
  };

  if (type === 'lakhCrores') {
    if (num >= 10000000) {
      return `${formatWithDecimals(num / 10000000)} Cr`;
    } else if (num >= 100000) {
      return `${formatWithDecimals(num / 100000)} Lac`;
    }

    return formatIndian(num);
  } else {
    if (num >= 1000000000) {
      return `${formatWithDecimals(num / 1000000000)} B`;
    } else if (num >= 1000000) {
      return `${formatWithDecimals(num / 1000000)} M`;
    }

    return formatIndian(num);
  }
};

export enum statusEm {
  IN_REVIEW = 'in_review',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted'
}

export const statusOptions = [
  {
    value: statusEm.IN_REVIEW,
    label: 'In review'
  },
  {
    value: statusEm.REJECTED,
    label: 'Rejected'
  },
  {
    value: statusEm.ACCEPTED,
    label: 'Accepted'
  }
];
